import { useQuery } from '@tanstack/react-query';

export function useProjectsReportsExportProcessQuery({
  exportProcessId,
  queryOptions,
}) {
  return useQuery({
    queryKey: ['projectsReports', 'exportProcesses', exportProcessId],
    queryFn: async () => {
      const response = await axios.get(
        `/projects_reports/export_processes/${exportProcessId}`,
      );

      return response.data;
    },
    refetchInterval: (data) =>
      !data || ['completed', 'failed'].includes(data.data.attributes.status) ?
        false
      : 1000,
    refetchIntervalInBackground: true,
    ...queryOptions,
  });
}
